import React from 'react'
import { useStoreState } from 'easy-peasy'
import ReactSelect from 'react-select'
import { Flex, Text } from 'rebass'
import { useField, useFormikContext } from 'formik'
import { useQuery } from 'react-apollo-hooks'
import get from 'lodash.get'
import { css } from 'styled-components/macro'

import queries from '../../queries'

const inputStyle = {
  control: (styles, { isFocused }) => ({
    display: 'flex',
    padding: '.3rem',
    backgroundColor: '#eff2f7',
    border: isFocused ? '1px solid #8181DD' : '1px solid transparent',
    hover: {
      border: '1px solid #8181DD',
    },
    '$:hover': {
      borderColor: '#8181DD',
    },
    boxShadow: 'none',
    borderRadius: '3px',
  }),
  input: () => ({
    backgroundColor: '#eff2f7',
  }),
  placeholder: () => ({
    color: '#AFB8C6',
    fontWeight: 300,
  }),
}

const GeofenceSelect = ({
  admin,
  name,
  label,
  ...others
}) => {
  const accountId = useStoreState(state => state.account.id)
  const variables = { accountId }
  const { data, error, loading } = useQuery(queries.geofences.LIST, {
    suspend: false,
    fetchPolicy: 'network-only',
    variables,
  })
  const [field, meta] = useField(name)
  const { setFieldValue, setFieldTouched } = useFormikContext()

  const options = get(data, 'geofence', []).map(g => ({
    value: g.id,
    label: `${g.name}`,
  }))

  // Manually update Formik values object
  const handleChange = value => setFieldValue(name, value || [])

  // Manually update Formik touched object
  const handleBlur = () => setFieldTouched(name, true)

  return (
    <Flex
      flexDirection="column"
      mb={3}
      width="100%"
    >
      {label && (
        <Text
          as="label"
          mb={2}
          fontSize={1}
          fontWeight="bold"
          color="3B4858"
          css={css`text-transform: uppercase;`}
        >
          {label}
        </Text>
      )}
      <Text
        {...others}
        mb={1}
        fontSize={2}
        as={ReactSelect}
        isMulti
        name={name}
        value={options.find(o => field.value === o.value)}
        onChange={handleChange}
        onBlur={handleBlur}
        isLoading={loading}
        isClearable
        isSearchable
        options={options}
        styles={inputStyle}
      />
      {meta.touch && meta.error && (
        <Text color="error">
          {meta.error}
        </Text>
      )}
      {error && (
        <Text color="error">
          {error}
        </Text>
      )}
    </Flex>
  )
}

export default GeofenceSelect
